import React, { useMemo } from "react";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import leftArrow from "assets/images/account-page/left-arrow.svg";
import propstreamAccountLogo from "assets/images/account-page/propstreamlogo-account.svg";
import css from "./style.scss";
import { useSelector } from "react-redux";
import { selectPlanDetails } from "../../data/user";

const AccountHeader = ({ location, history }) => {
  const planDetails = useSelector(selectPlanDetails)?.toJS();
  // Define the mapping for routes and titles
  const routeTitleMap = {
    "/accountnew/plan": "Manage Plan",
    "/accountnew/billing": "Billing",
    "/accountnew/teams": "Teams",
    "/accountnew/profile": "Profile",
    "/accountnew/leadautomator": planDetails?.usedLATrial === false ? "PropStream Connect Trial" : "PropStream Connect",
    "/accountnew/manageleadautomator": planDetails?.usedLATrial === false ? "PropStream Connect Trial" : "PropStream Connect",
    "/accountnew/teamdowngrade": "Manage Team Member",
    "/accountnew/team": "New Team Member",
    "/accountnew/reviewpendingchanges": "Manage Team Member",
    "/accountnew/reviewteam": "Manage Team Member"
  };

  // Find the section title based on the current route
  const sectionTitle = useMemo(() => {
    return Object.entries(routeTitleMap).find(([path]) =>
      location.pathname.startsWith(path)
    )?.[1] || "Account";
  }, [location.pathname]);

  const showBackButton = sectionTitle !== "Account";

  return (
    <div className={classNames(css.clsMainHeader, showBackButton ? css["clsMainHeader-withBack"] : css["clsMainHeader-withoutBack"] )}>
      {showBackButton ? (
        <>
          <a
            onClick={() => history.push("/accountnew/landing")}
            className={classNames(
              css.text_link_hover, css.backIcon)}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="Back" />
          </a>
          <div className={css.logoWrapper}>
            <div className={css.clearfix}>
              <h5 className={css.clsHeaderSubHeading}>ACCOUNT</h5>
              <h4 className={css.clsHeaderHeading}>{sectionTitle}</h4>
            </div>
          </div>
        </>
      ) : (
        <div className={css.logoWrapper}>
          <h4 className={css.clsHeaderHeading}>Account</h4>
          <img src={propstreamAccountLogo} alt="PropStream Logo" className={css.logo} />
        </div>
      )}
    </div>
  );
};

export default withRouter(AccountHeader);
